export enum UserRole {
  Admin = "Admin",
  DeliveryCompany = "DeliveryCompany",
  CompanyManager = "CompanyManager"
}

export enum CompanySection {
  Dashboard = "Dashboard",
  Orders = "Orders",
  Drivers = "Drivers",
  StaffManagement = "StaffManagement",
  CompanySettings = "CompanySettings",
  Financial = "Financial"
}
